import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import json from '../../e3crm_de.json'

const i18n = i18next.createInstance()
i18n.use(initReactI18next).init({
  lng: 'de',
  resources: { de: { translation: json } },
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
})
